module.exports = __webpack_public_path__ + "static/design_style_v2-a7f794b2e361c1ffa459ab0097fd29fd.png";